export default {
  "content": "<path d=\"M11 4.5H5.76c-.674 2.674-.36 4.808.039 7.145.387 2.27.853 4.733.395 7.855h11.979c.166-.995.208-1.84.208-3h2c0 1.546-.07 2.654-.403 4.21-.099.46-.507.79-.978.79H5a1 1 0 01-.978-1.21c.705-3.29.244-5.74-.195-8.31-.442-2.586-.856-5.286.218-8.774A1 1 0 015 2.5h6v2z\" fill=\"#7B61FF\"/><path d=\"M22.246 4.081l-2.587 3.622h1.773v2h-2.715v.973h2.715v2h-2.715v1.973h-2v-1.973H14v-2h2.717v-.973H14v-2h1.773l-2.587-3.622 1.627-1.162 2.903 4.063 2.903-4.063 1.627 1.162z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};